import script from "./enquiry_details.vue?vue&type=script&setup=true&lang=js"
export * from "./enquiry_details.vue?vue&type=script&setup=true&lang=js"

import "./enquiry_details.vue?vue&type=style&index=0&id=40d4b51b&lang=css"

const __exports__ = script;

export default __exports__